var antPrefixCls = '.ant-slider';
var genBaseStyle = function genBaseStyle(token) {
  var _ref;
  return _ref = {}, _ref[antPrefixCls] = {}, _ref;
};

// ============================== Export ==============================
var sliderStyleFn = function sliderStyleFn(token) {
  return [genBaseStyle()];
};

export { sliderStyleFn };
